import { Link } from 'react-router-dom';
import { useFlag } from '../../context/FeatureFlagsContext';
import { useReviewWindow, daysLeftText } from '../../hooks/useReviewWindow';

// Per-item tag on a delivered order: "Review · 12 days left" / "✓ Reviewed" / "🔒 Expired".
export function ReviewItemTag({ order, productId, index, modern = false }) {
  const on = useFlag('customer.reviews', false) && order?.status === 'delivered';
  const win = useReviewWindow((order?.items || []).map((i) => i.product_id), on);
  const st = win?.items?.[productId];
  if (!on || !st || !st.purchased) return null;

  const soon = st.days_left != null && st.days_left <= 3;
  const kind = st.reviewed ? (st.open ? 'reviewed' : 'reviewed-locked') : st.open ? 'open' : 'expired';
  const text = {
    open: `Review${st.days_left == null ? '' : ` · ${daysLeftText(st.days_left)}`}`,
    reviewed: '✓ Reviewed',
    'reviewed-locked': '✓ Reviewed',
    expired: '🔒 Expired',
  }[kind];
  const cls = modern
    ? `inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold border ${
      kind === 'open' ? (soon ? 'border-[#D97706] text-[#B45309]' : 'border-[#047857] text-[#047857] hover:bg-[#ECFDF5]')
        : kind === 'expired' ? 'border-[#E7E5E0] text-[#A8A29E]' : 'border-[#D1FAE5] text-[#047857] bg-[#ECFDF5]'}`
    : `inline-flex items-center px-1.5 py-0.5 font-mono text-[10px] uppercase border ${
      kind === 'open' ? (soon ? 'border-[#FF9F0A] text-[#FF9F0A]' : 'border-[#39FF14] text-[#39FF14] hover:bg-[#39FF14]/10')
        : kind === 'expired' ? 'border-[#2A0F3D] text-[#4B6B52]' : 'border-[#39FF14]/40 text-[#39FF14]/80'}`;
  const tid = `order-item-review-${index}`;
  return kind === 'open'
    ? <Link to={`/customer?open=${productId}`} className={cls} data-testid={tid} data-state={kind}>{text}</Link>
    : <span className={cls} data-testid={tid} data-state={kind}>{text}</span>;
}
